export interface ToggleAction {
  (value?: boolean | ((currState: boolean) => boolean)): void;
  on(): void;
  off(): void;
}

export const createToggler = <T extends Record<string, any>>(
  key: {
    [K in keyof T]: T[K] extends boolean ? K : never;
  }[keyof T],
  set: (
    partial: T | Partial<T> | ((state: T) => T | Partial<T>),
    replace?: false | undefined,
    actionName?: string,
  ) => void,
  baseActionName?: string,
) => {
  const toggler: ToggleAction = (v) => {
    if (typeof v === 'boolean') return set({ [key]: v } as Partial<T>, undefined, baseActionName);
    if (typeof v === 'function') return set((s) => ({ [key]: v(s[key]) } as Partial<T>), undefined, baseActionName);
    return set((s) => ({ [key]: !s[key] } as Partial<T>), undefined, baseActionName);
  };
  toggler.on = () => set({ [key]: true } as Partial<T>, undefined, `${baseActionName}/on`);
  toggler.off = () => set({ [key]: false } as Partial<T>, undefined, `${baseActionName}/off`);

  return toggler;
};
